var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradableIconPlayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.828 2.47h-8.7a2.175 2.175 0 00-2.176 2.176v17.402a2.175 2.175 0 002.175 2.175H20.18a2.175 2.175 0 002.175-2.175V8.997L15.828 2.47z",
    stroke: "#3A3A3A",
    strokeWidth: 1.482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.433 9.432h4.405M8.433 12.042h5.22M8.433 14.652h3.915M15.83 2.47v6.527h6.525",
    stroke: "#3A3A3A",
    strokeWidth: 1.305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gradableIconPlayer_svg__clip0_1452_5228)",
    stroke: "#3A3A3A",
    strokeWidth: 1.305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.569 18.568a3.045 3.045 0 100-6.09 3.045 3.045 0 000 6.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92 18.085l-.526 3.963 2.175-1.305 2.175 1.305-.526-3.968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gradableIconPlayer_svg__clip0_1452_5228"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.653 10.737)",
    d: "M0 0h7.831v13.051H0z"
  })))));
}
export default SvgGradableIconPlayer;